import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import { Anchor } from '../../Components/Anchor'
import { useHistory, useRouteMatch } from 'react-router-dom'
import PromofyHeaderSelfServeIcon from '../../Assets/Images/icons/oppiziHeaderSelfServe'
import { EDDMLogo } from '../../Assets/Images/icons/EDDMlogo'
import ArrowBottomIcon from '../../Assets/Images/icons/arrowBottom'
import Popover from '@material-ui/core/Popover'
import { PATHS } from '../../Config/Routing/paths'
import { styles } from './styles'
import { authorization } from '../../Module/Auth/Auth'
import { userLogout } from '../../Reducers/Auth/actions'
import ProfileIcon from '../../Assets/Images/icons/profile'
import LogoutIcon from '../../Assets/Images/icons/logoutNewDesign'
import { EDDM_SIGNUP } from '../../shared/constants'

const HeaderSelfServe = ({ classes, img, userName, clientName }) => {
  const dispatch = useDispatch()
  const match = useRouteMatch()
  const history = useHistory()
  const { client } = authorization.getUser()
  const isEddmSignup = client.createdBy === EDDM_SIGNUP
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const ACTIONS = [
    {
      title: 'Profile',
      onClick: e => {
        const isCtrlClick = e.ctrlKey || e.metaKey
        if (!isCtrlClick) {
          handleClose()
        }
      },
      href: `${match.path}${PATHS.dashboard.profile}`,
      icon: <ProfileIcon />,
    },
    {
      title: 'Logout',
      onClick: () => {
        dispatch(userLogout())
        authorization.logout()
        history.push(PATHS.main.login)
      },
      icon: <LogoutIcon />,
    },
  ]

  useEffect(() => {
    const metaViewport = document.createElement('meta')
    metaViewport.setAttribute('name', 'viewport')
    metaViewport.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0',
    )
    document.head.appendChild(metaViewport)
  }, [])

  return (
    <div className={classes.wrapper}>
      <div className={classes.main}>
        {isEddmSignup ? <EDDMLogo /> : <PromofyHeaderSelfServeIcon />}
        <div
          onClick={handleClick}
          className={classNames(classes.user, { [classes.open]: open })}
        >
          <div className={classes.userPicture}>
            <img src={img} alt="User profile" />
          </div>
          <div className={classes.names} cypress_id={'headerSelfServeNames'}>
            <div
              className={classes.clientName}
              cypress_id={'headerSelfServeClientName'}
            >
              {clientName}
            </div>
            <div
              className={classes.userName}
              cypress_id={'headerSelfServeUserName'}
            >
              <div>{userName}</div>
              <div
                className={classNames(classes.arrow, {
                  [classes.rotate]: open,
                })}
              >
                <ArrowBottomIcon />
              </div>
            </div>
          </div>
        </div>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          style={{ marginTop: '10px' }}
        >
          <div className={classes.popoverWrapper}>
            {ACTIONS.map(({ title, icon, onClick, href }, index) => {
              return title.toLowerCase() === 'profile' ? (
                <Anchor key={index} href={href}>
                  <div key={title} onClick={onClick} className={classes.item}>
                    <div className={classes.icon}>{icon}</div>
                    <div
                      className={classes.title}
                      cypress_id={'headerSelfServeTitle'}
                    >
                      {title}
                    </div>
                  </div>
                </Anchor>
              ) : (
                <div key={title} onClick={onClick} className={classes.item}>
                  <div className={classes.icon}>{icon}</div>
                  <div className={classes.title}>{title}</div>
                </div>
              )
            })}
          </div>
        </Popover>
      </div>
    </div>
  )
}

export default injectStyles(styles)(HeaderSelfServe)
